// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__1UJtw","active":"Uploader_active__2j7c8"};